// Async Thunk for fetching service items
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchServiceItems = createAsyncThunk(
  "serviceItems/fetchServiceItems",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/service-items`, {
        headers: {
          'Accept-Language': lang || 'en',
          'Accept': 'application/json'
        }
      });
     
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch service items";
      return rejectWithValue({ message });
    }
  }
);
